
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'NFilterFormDivider'
})
export default class NFilterFormDivider extends Vue {}
